export const WarehouseMinLength = 2;
export const WarehouseMaxLength = 150;
export const WarehouseDebounceTime = 300;
export const RequestLimit = 200;
export const WarehouseControlName = 'Warehouse';
export const WarehouseLabel = 'Відділення';
export const WarehousePlaceholder = '';
export const WarehouseClasses = 'form-col w-70';
